import { call, takeLatest } from 'redux-saga/effects';

import { SET_BREAKPOINT } from 'app/shared/modules/globalEvents/constants';
import { removeTooltips } from 'app/dealer/shared/utils/dom/dom';

export function* handleChartTooltipsSaga() {
  yield call(removeTooltips);
}

export function* watchWindowBreakpointChange() {
  yield takeLatest(SET_BREAKPOINT, handleChartTooltipsSaga);
}
